import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-despesa-planejamentos',
  templateUrl: './despesa-planejamentos.component.html',
  styleUrls: ['./despesa-planejamentos.component.css']
})
export class DespesaPlanejamentosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
